import router from '@/router/index'
// import axios from 'axios'

import VehicleService from "@/api/VehicleService";
// import driverService from '@/api/driverService';
import vehicleTypeService from "@/api/vehicleTypeService";
import billingService from '@/api/billingService';
import FileSaver from 'file-saver'
import { MESSAGES } from '@/utils/constants';
import { notifyApiError ,notifyError,notify} from '@/utils/notification-helper';
import deviceService from '@/api/device';
import { VEHICLE_STATUS } from '@/utils/map/mapUtils';
import moment from "moment-timezone";
const state = {

    editVehicleData: {},
    editField: false,
    vehicleFileList: [],
    vehicleDataTemp:[],
    devices: [],
    vehicleTypes: [],

    editId: null,
    fileUrlView: null,
    fileUrlDownload: null,
    additionalDetails: [
    ],
    metadata: {},
    selectedVehicleColumns: [],
    drivers: [],
    billingTypes: [],
    vehicleFuelTypes: [],
    vehicleModels: [],
    EmployeeErrors:[],
    vehicleId:null,
    title:'Vehicle Error',
    loader: false,

    bulkFiles:null,
    vehicleData: [],
  
}
const getters = {
    getVehicles: (state, getters, rootState, rootGetters) => rootGetters.getVehicles ?  rootGetters.getVehicles : [],
    getVehicleTypes:  (state, getters, rootState, rootGetters) => rootGetters.getVehicleTypes ?  rootGetters.getVehicleTypes : [],
    editVehicleData: state => state.editVehicleData,
    editField: state => state.editField,
    editId: state => state.editId,
    vehicleFileList: state => state.vehicleFileList,
    fileUrlView: state => state.fileUrlView,
    fileUrlDownload: state => state.fileUrlDownload,
    getSelectedFacility: (state, getters, rootState) => {
        return rootState.selectedFacility;
    },
    selectedVehicleColumns: state => state.selectedVehicleColumns,
    getDrivers: (state, getters, rootState, rootGetters) => rootGetters.getDrivers,
    getVehicleData:(state)=> {
        return state.vehicleData
    },
    getDevices: (state, getters, rootState, rootGetters) => rootGetters.getDevices ,
    getIMEINumbers: (state, getters, rootState, rootGetters) => (data, imeiFilter) => {
        return rootGetters.getDevices.filter((dev) => {
            if (data && dev.imei === data.imei) 
                return true;
            else if (rootGetters.getVehicles.find(vd => vd.imei === dev.imei )) 
                return false;
            else if (imeiFilter && imeiFilter.value)
                return dev.imei.toUpperCase().includes(imeiFilter.value.toUpperCase());
            else 
                return true;
        });
    },
    getVehicleModelDropdown :(state) => state.vehicleModels,
    getVehicleFuelTypes :(state, getters, rootState, rootGetters) => {
        console.log("#fuel",rootGetters.getFuelTypes);
        return rootGetters.getFuelTypes
    }

};

const actions = {
    async getVehicleFileList({ commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        try {
            const res = await VehicleService.getVehicleFileByid(channelKey,id)
            commit('getFile', res.data.result);
        } catch (error) {
            console.error("Error while fetching file List : ", error);
            commit('getFile', "Data not available");
            return false;
        }
    },
    async uploadFile({ commit,rootState }, data) {
        data.channelKey = rootState.fileUploadChannelKey
        await VehicleService.uploadFile(data)
        commit('upload')

    },
    async addVehicle({ commit, dispatch }, item) {
       
        try {
            const response = await VehicleService.addVehicle(item);
            console.log('bulk Upload: ',response.data.result, state.bulkFiles);
            if(response.data.result.id && state.bulkFiles) { 
                let data = {
                   id:response.data.result.id,
                   data:state.bulkFiles
                }
                dispatch("uploadFile",data);
                notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            }
            dispatch('addVehicle', response.data.result, { root: true });
            // dispatch('loadInitialData', null, { root: true });
            commit('add', item);
            return response;
        } catch (error) {
            if (error.response.status == 409) {
                notifyError(error.response.data.message);
            } else {
                notifyError(MESSAGES.CHANGES_SAVE_ERROR);
            }
            return error.response;
        }
    },
    async editVehicle({ commit }, item) {
        // const res = await VehicleService.getVehicleById(item.id)
        // console.log("vehicle",item)
        commit('edit', item);
        router.push({ name: "VehicleForm", params: { add: false } });
    },
    async updateVehicle({ dispatch }, item) {
        if(item.data.idle){
            delete  item.data.idle  
        }
        if(item.data.speed){
            delete  item.data.speed  
        }
        try {
        const response = await VehicleService.updateVehicle(item.id, item.data);
        console.info('Response from update Vehicle API ', response.data);
        if(state.editId && state.bulkFiles) { 
            let data={
                id:state.editId,
                data:state.bulkFiles
            }  
            dispatch("uploadFile",data);
        }
        notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        dispatch('updateVehicle', response.data.result, { root: true });
        // commit('update', item);
        // dispatch("loadVehicles");
        } catch(error) {
            if (error.response.status == 409) {
                notifyError(error.response.data.message);
            } else {
                notifyError(MESSAGES.CHANGES_SAVE_ERROR);
            }
        }
    },
    async deleteVehicle({ commit }, id) {
        await VehicleService.deleteVehicle(id);
        commit('removeVehicle', id, { root: true });
        // commit('delete', id);
    },
    async fetchVehicleFuelTypes ({ commit }) {
        const response = await VehicleService.getVehicleFuelTypes();
        commit('setVehicleFuelTypes', response.data.result);
    },
    // async downloadFile({ commit }, data) {
    //     console.log("data", data)
    //     // window.open("../../assets/images/sandy.jpg", '_blank');

    //     axios.post(data.url, { responseType: 'blob' })
    //         .then(response => {
    //             const url = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', data.type);
    //             document.body.appendChild(link);
    //             link.click();
    //             this.posts = response.data
    //         })
    //         .catch(e => {
    //             this.errors.push(e)
    //         })
    //     commit('downloadFile');


    // },
    async deleteFile({ commit,rootState }, data) {
        data.channelKey = rootState.fileUploadChannelKey
        await VehicleService.deleteFile(data)
        // commit('delete', id);
        commit('deleteFile', data)
    },
    async viewFile({ commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        const response = await VehicleService.viewFile(channelKey,id)
        commit('setUrlView', response.data.result)
    },
    async downloadFile({ commit,rootState }, id) {
        let channelKey = rootState.fileUploadChannelKey
        const response = await VehicleService.downloadFile(channelKey,id)
        commit('setUrlDownload', response.data.result)
    },
    async getColumn({ commit }) {
        const res = await VehicleService.getColumn()
        commit('getColumn', res.data.result)
    },
    getSearchData({commit,state},e){
       // console.log("word",e.target.value)
        let word = e.target.value
        state.vehicleDataTemp = state.vehicleData.slice(0)
        let list
        const search = word.trim().toLowerCase()
        if (!search.length) { list = state.vehicleData }
        else {
            list = state.vehicleDataTemp.filter(item => item.vehicleRtoNum.toLowerCase().indexOf(search) > -1)
        }
        commit("get",list)

    },
    async loadVehicles({ commit }) {
        try {
            const response = await VehicleService.getVehicle();
            const vehicles = response.data.result.map((v) => ({ ...v, status: VEHICLE_STATUS.NO_SIGNAL,idle:"-" }));
            commit('setVehicles', vehicles, { root: true });
        } catch (err) {
            commit('setLoader', false);
            console.log('#ERR', err);
        }
    },
    async refreshVehicles({ commit }) {
        try {
            const response = await VehicleService.getVehicle();
            const vehicles = response.data.result.map((v) => {
                //delete v.idle
                return { ...v, status: v.liveStatus ? v.liveStatus : VEHICLE_STATUS.NO_SIGNAL,dateTime:moment(v.dateTime + "Z").format('DD-MM-YYYY HH:mm:ss'),
                idle: v.idle ? parseInt(v.idle.totalHours) + ":" + parseInt(v.idle.totalMinutes).toString().substring(0,2)  + ":"
                + parseInt(v.idle.totalSeconds).toString().substring(0,2)  : ''} 
            
        });
        commit('updateVehicles', vehicles);
        } catch (err) {
            commit('setLoader', false);
            console.log('#ERR', err);
        }
    },
    async fetchVehicleTypes({commit}) {
        const response = await vehicleTypeService.getAllVehicleTypes();
        const sortedResult = response.data.result.sort((a, b) => a.createdAt - b.createdAt);
        commit('setVehicleTypes', sortedResult);
    },
    async fetchBillingTypes ({ commit }) {
        try {
            const response = await billingService.listAllBillCategory();
            const data = response.data;
            commit('setBillingTypes', data);
        } catch (err) {
            console.log('Error: ', err);
        }
    },
    async fetchVehicleModels ({ commit, rootState }) {
        try {
            const filters = {
                facilityID: rootState.selectedFacility.id,
                tenantID: rootState.tenantData.id
            }
           
            const response = await VehicleService.getVehicleModels(filters);
            const data = response.data;
            if (!data.vehicleModels) {
                data.vehicleModels = [];
            }
            const arr = data.vehicleModels.map((val, i) => ({ name: val, id: i }));
            commit('setVehicleModels', arr);
        } catch (err) {
            console.log('Error: ', err);
        }
    },
    async DownloadTemp({ commit }) {
        await VehicleService.vehicleDownloadTemplate().then(({ data }) => {
            FileSaver(data, 'Vehicle' + '.xlsx')
        }).catch(notifyApiError);
        commit('downloadData')
    },
    uploadTemplate({ dispatch,commit }, event) {
        let data = new FormData();
        let file = event.target.files[0];
        data.append('name', 'my-file')
        data.append('file', file)
        let config = {
            header: {
                'Content-Type': 'multipart/form-data',
            }
        }
        VehicleService.vehicleUploadTemplate( data, config).then((res) => {
            state.EmployeeErrors = []
            let resData = res.data.templateErrorMessage
            if (resData.length != 0) {
                notifyError(MESSAGES.RESOLVE_ERRORS)
                 commit("employeeError", resData)

            }
            else {
                console.log('Upload message');
                notify(MESSAGES.TEMPLATE_UPLOAD_SUCCESS);
                res.data.result.forEach((ele) => {
                    dispatch('addVehicle', ele, { root: true });
                });
                // dispatch('getVehicle', state.vehicleId);
                // dispatch('loadVehicles',);
            }
        }).catch((err) => {
            notifyApiError(err)
        })
    },
    async fetchDevices ({ commit }) {
        const devices = await deviceService.getDevices();
        commit("setDevices", devices.data.result);
    },
    async vehicleModelDropdown ({ commit,rootState }) {
        const filters = {
            facilityID: '',
            tenantID: rootState.tenantID
        }
        const response = await VehicleService.getCommonVehicleModels(filters);
        commit("setVehicleModelDropdown",response.data.vehicleModels)
    },
    
}
const mutations = {
    setUrlView(state, url) {
        // console.log(url)
        state.fileUrlView = url
    },
    setUrlDownload(state, url) {
        state.fileUrlDownload = url
    },
    get(state, item) {
        state.vehicleData = item
    },
    updateVehicles(state, item) {
        state.vehicleData = item
    },
    add(state) {

        // state.vehicleData.slice();
        // state.vehicleData.push(item);
        state.editField = false,
            state.editVehicleData = {},
            router.push("/vehicle-management");
        state.metadata = {}
    },
    edit(state, item) {
        state.editId = item.id;
        state.editVehicleData = item;
        // state.editVehicleData.driverID = 
        state.metadata = item.metaData ? item.metaData : {}
        state.editField = true;
        console.log('Proceeding to add', state.editVehicleData);
        // router.push("/vehicle-management/add");
    },
    delete(state, vehicleId) {
        state.editField = false
        var vehicles = state.vehicleData;
        const index = vehicles.map(item => item.id).indexOf(vehicleId);
        vehicles.splice(index, 1);
    },
    update(state) {
        state.editField = false,
        state.editVehicleData = {}
        state.metadata = {}
    },
    cancel(state) {
        state.editField = false,
            state.editVehicleData = {}
        state.metadata = {}
    },
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    //file upload
    getFile(state, item) {
        if (item == 'Data not available') {
            state.vehicleFileList = []
        }
        else {
            state.vehicleFileList = item

        }

    },
    setSelectedVehicleColumns(state, columns) {
        state.selectedVehicleColumns = columns;
    },
    setDrivers(state, data) {
        state.drivers = data;
    },
    setBillingTypes(state, data) {
        state.billingTypes = data;
    },
    setVehicleFuelTypes(state, data) {
        state.vehicleFuelTypes = data;
    },
    setVehicleModels(state, data) {
        state.vehicleModels = data;
    },
    getColumn(state, data) {
        state.additionalDetails = data

    },
    setDevices(state, devices) {
        state.devices = devices;
    },
    employeeError(state, data) {
        // console.log("error",data)
         data.map(data => {
             if (data.error) {
                 state.EmployeeErrors.push({ error: data.error, email: data.notAddedEmployee.emailID, empID: data.notAddedEmployee.employeeCode, empName: data.notAddedEmployee.name, })
             }
             else {
                 state.EmployeeErrors.push({ error: data.errorMessage, cell: data.cell })
             }
         })
     },
    setVehicleTypes (state, data) {
        state.vehicleTypes = data;
    },
    upload() {

    },
    downloadFile() {

    },
    downloadData(){

    },
    setLoader(state, value) {
        state.loader = value;
    },
    addTempFile(state,file){
        state.vehicleFileList.push({"fileName":file.name,"fileType":file.type,"fileUrl":"Local storage",id:file.id})
    },
    assignBulkFile(state,files){
        console.log('Assigning bulk files', files);
        state.bulkFiles = files
    },
    deleteFile(state,data){
        if(data.referenceID)
        {const index = state.vehicleFileList.map(item => item.id).indexOf(data.id)
        state.vehicleFileList.splice(index, 1)}
        else{
            const index = state.vehicleFileList.map(item => item.id).indexOf(data.id) 
            state.vehicleFileList.splice(index, 1)
        }
    },
    clearFields(state){
        state.vehicleFileList = []
    },
    setVehicleModelDropdown(state,data){
        console.log("#mutation",data)
        state.vehicleModels=data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}